import { useEffect } from "react";
import { useLocation, useParams, matchPath } from "react-router-dom";

// Maps route pattern → friendly page name for <title>
const ROUTE_TITLES = [
  { pattern: "/", name: "Home" },
  { pattern: "/vehicles", name: "Vehicles" },
  { pattern: "/routes", name: "Daily Routes" },
  { pattern: "/tours", name: "Tours" },
  { pattern: "/tours/:id", name: "Tour Detail" },
  { pattern: "/about", name: "About Us" },
  { pattern: "/contact", name: "Contact" },
  { pattern: "/custom-booking", name: "Custom Booking" },
  { pattern: "/accept-quote/:bookingId", name: "Accept Quote" },
  { pattern: "/faq", name: "FAQ" },
  { pattern: "/book", name: "Book a Seat" },
  { pattern: "/book/form", name: "Booking Details" },
  { pattern: "/book/confirm/:bookingId", name: "Booking Confirmation" },
  { pattern: "/lookup", name: "Booking Lookup" },
  { pattern: "/login", name: "Sign In" },
  { pattern: "/dashboard", name: "My Dashboard" },
  { pattern: "/driver/login", name: "Driver Sign In" },
  { pattern: "/driver", name: "Driver Dashboard" },
  { pattern: "/payment/success", name: "Payment Success" },
  { pattern: "/payment/cancel", name: "Payment Cancelled" },
  { pattern: "/seo/:slug", name: "Guide" },
  { pattern: "/admin/login", name: "Admin Sign In" },
  { pattern: "/admin", name: "Admin Dashboard" },
  { pattern: "/admin/bookings", name: "Admin • Bookings" },
  { pattern: "/admin/leads", name: "Admin • Leads" },
  { pattern: "/admin/seo", name: "Admin • SEO Pages" },
  { pattern: "/admin/settings", name: "Admin • Settings" },
  { pattern: "/admin/vehicles", name: "Admin • Vehicles" },
  { pattern: "/admin/drivers", name: "Admin • Drivers" },
  { pattern: "/admin/routes", name: "Admin • Routes" },
  { pattern: "/admin/tours", name: "Admin • Tours" },
  { pattern: "/admin/slogans", name: "Admin • Slogans" },
  { pattern: "/admin/calendar", name: "Admin • Calendar" },
  { pattern: "/admin/notifications", name: "Admin • Notifications" },
];

function resolveTitle(pathname) {
  // Prefer longest / most-specific match
  const matches = ROUTE_TITLES
    .map(r => ({ ...r, m: matchPath({ path: r.pattern, end: true }, pathname) }))
    .filter(x => x.m);
  if (matches.length === 0) return null;
  matches.sort((a, b) => b.pattern.length - a.pattern.length);
  return matches[0].name;
}

export default function TitleUpdater() {
  const loc = useLocation();
  useEffect(() => {
    const name = resolveTitle(loc.pathname) || "Shruti Tours & Travels";
    document.title = `Shruti T&T | ${name}`;
  }, [loc.pathname]);
  return null;
}
